import ErrorMessage from '@components/atoms/ErrorMessage';
import FormField from '@components/atoms/FormField';
import GridBox from '@components/atoms/GridBox';
import OnboardingButtonBar from '@components/molecules/button-bar/OnboardingButtonBar';
import { CarrierId, Maybe } from '@graphql/generated';
import {
  OldCarrierFormResult,
  QuoteInitialForm,
} from '@lib/data/typesQuestions';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';

const carriers = {
  [CarrierId.Allianz]: 'Allianz',
  [CarrierId.Azul]: 'Azul',
  [CarrierId.Bradesco]: 'Bradesco',
  [CarrierId.Hdi]: 'HDI',
  itau: 'Itaú',
  [CarrierId.Ituran]: 'Ituran',
  [CarrierId.Suhai]: 'Suhai',
  liberty: 'Liberty / Aliro',
  [CarrierId.Mapfre]: 'Mapfre',
  [CarrierId.Porto]: 'Porto Seguro',
  sompo: 'Sompo',
  sulamerica: 'SulAmérica',
  [CarrierId.Tokio]: 'Tokio Marine',
  usebens: 'Usebens',
  zurich: 'Zurich',
  youse: 'Youse',
  caixa: 'Caixa Seguradora',
  bancoDoBrasil: 'Banco do Brasil',
  associacao: 'Associação',
  protecaoVeicular: 'Proteção Veicular',
  others: 'Outras',
};

function generateLabelValue(item?: Maybe<string>) {
  return item ? { label: item, value: item } : null;
}

interface Props {
  onSubmit: (data: OldCarrierFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const ActualCarrierForm = ({ onSubmit, item }: Props) => {
  const { handleSubmit, errors, control } = useForm<{
    carrier: { value: string };
  }>();
  return (
    <form
      onSubmit={handleSubmit((data) =>
        onSubmit({
          oldPolicy: {
            carrier: data.carrier.value,
          },
        }),
      )}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <FormField style={{ width: '100%' }}>
            <Controller
              name="carrier"
              control={control}
              rules={{ required: 'Precisamos da seguradora' }}
              defaultValue={generateLabelValue(item.oldPolicy?.carrier)}
              render={(field) => (
                <Select
                  {...field}
                  options={Object.entries(carriers).map(([id,label]) => ({
                    label,
                    value: id,
                  }))}
                  placeholder="Selecione a seguradora"
                  noOptionsMessage={() => 'Não encontrada'}
                />
              )}
            />
            {(errors.carrier as { message?: string })?.message && (
              <ErrorMessage>
                {(errors.carrier as { message?: string }).message}
              </ErrorMessage>
            )}
          </FormField>
        </GridBox>
      </GridBox>
      <OnboardingButtonBar text="Continuar" loading={false} />
    </form>
  );
};

export default ActualCarrierForm;
